import {
    asyncFetchDataAwaitableActionFactory,
} from "../../../core/core-redux/actions/asyncFetchDataAction";
import { wfsService, WfsServiceResponse, WfsServiceServiceParams } from "./wfsService.service";

export const WFS_SERVICE = "WFS_SERVICE";

export const wfsServiceActionCreator = asyncFetchDataAwaitableActionFactory<
    WfsServiceServiceParams,
    WfsServiceResponse,
    any
>(WFS_SERVICE, wfsService);
